import React from "react";
import PropTypes from "prop-types";
import RPKMExpressions from "../RPKMExpressions";
import HelperText from "../../../../components/atoms/HelperText";

const Expressions = ({ item, idx }) => {
  // Convert rpkm dict to a list to sort them.
  const rpkm = [];
  for (const expression in item.expressions_rpkm) {
    rpkm.push({
      expression: expression.replace(/_/g, " "),
      value: item.expressions_rpkm[expression].toFixed(2),
    });
  }
  rpkm.sort((a, b) => {
    return b.value - a.value;
  });

  if (rpkm.length > 0) {
    <div>
      <div className="varsome-horiz-list-label" style={{ textAlign: "center" }}>
        RPKM
        <HelperText fieldDescriptionKey="RPKM" />
      </div>
      <RPKMExpressions data={rpkm} uniqueKey={idx} />
    </div>;
  }

  return null;
};

const { shape, number } = PropTypes;

Expressions.propTypes = {
  item: shape({}),
  idx: number,
};

Expressions.defaultProps = {
  item: null,
  idx: null,
};
export default Expressions;
